import React from "react";

import LinkOutlined from "../image/LinkOutlined";
import { EmptyText, WordBreak } from "../common/CellText";

const LinkedTask = (props) => {
    const { linkedTaskList } = props;
    const renderTitle = (string) => {
        if (string) {
            if (string.length <= 100) return string;
            return <div>{string.substring(0, 100).concat("...")}</div>;
        }
    };
    return (
        <div>
            {linkedTaskList && linkedTaskList.length > 0 ? (
                linkedTaskList.map((task) => (
                    <div key={task.task_code}>
                        <a
                            style={{
                                display: "flex",
                                color: "#0075FF",
                                alignItems: "baseline",
                                gap: 4,
                                textDecoration: "underline",
                                lineHeight: "20px",
                                textUnderlineOffset: 2,
                            }}
                            className="linked"
                            onClick={() =>
                                window.open(
                                    `/mission/view/${task.task_code}`,
                                    "_blank"
                                )
                            }
                        >
                            <span>
                                <LinkOutlined />
                            </span>
                            {WordBreak(
                                renderTitle(`Chủ trì: ${task.name_user}`)
                            )}
                        </a>
                    </div>
                ))
            ) : (
                <EmptyText>Không có.</EmptyText>
            )}
        </div>
    );
};

LinkedTask.propTypes = {};

export default LinkedTask;
